'use client';

import { Button } from '@petsmart-ui/sparky';
import cn from 'classnames';

import './purchase-button.scss';

type PurchaseButtonProps = Readonly<{
    text: string;
    type?: 'button' | 'submit';
    disabled?: boolean;
    loading?: boolean;
    isSuccess?: boolean;
    formId?: string;
    fulfillmentMethod?: string;
    testId?: string;
    onClick?: () => void;
}>;

export function PurchaseButton({
    text,
    type = 'submit',
    disabled = false,
    loading = false,
    isSuccess = false,
    formId,
    fulfillmentMethod,
    testId = 'purchase-button',
    onClick,
}: PurchaseButtonProps) {
    return (
        <div
            className={cn('add-to-cart-button__surface', {
                'add-to-cart-button__surface--submitting': loading,
            })}
        >
            <Button
                size="lg"
                fullWidth
                type={type}
                text={text}
                variant="primary"
                disabled={disabled}
                aria-disabled={loading || disabled}
                loading={loading}
                form={formId}
                data-fulfillmethod={fulfillmentMethod}
                data-testid={testId}
                className={isSuccess ? 'add-to-cart-button--success' : undefined}
                onClick={onClick}
            />
        </div>
    );
}
